<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="eventGroup && eventGroup.id">{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!eventGroup || !eventGroup.id">{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="event-group-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-3">
        <app-image-input [form]="form" controlName="logo" newControlName="new_logo"></app-image-input>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.WEB_NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="web_name" />
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.FOUNDED_YEAR' | translate }}</label>
          <input type="number" class="form-control" formControlName="founded_year" />
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.INDUSTRY' | translate }}</label>
          <app-industry-select [parentFormGroup]="form"></app-industry-select>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="form-group">
          <app-industries-select [FormControl]="form.get('industries')"></app-industries-select>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.PRIORITY' | translate }}</label>
          <app-type-select
            [parentFormGroup]="form"
            [passFormControlName]="'priority_id'"
            [groupType]="'event_group_priorities'"
          ></app-type-select>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.VISITORS' | translate }}</label>
          <input type="number" class="form-control" formControlName="visitors" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.ORGANIZER' | translate }}</label>
          <input type="text" class="form-control" formControlName="organizer" />
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.EXHIBITORS' | translate }}</label>
          <input type="number" class="form-control" formControlName="exhibitors" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.REPEAT' | translate }}</label>
          <app-type-select
            [parentFormGroup]="form"
            [passFormControlName]="'repeat_id'"
            [groupType]="'event_group_repeats'"
          ></app-type-select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.FOREIGN_EXHIBITORS' | translate }}</label>
          <input type="number" class="form-control" formControlName="foreign_exhibitors" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.WEBSITE_URL' | translate }}</label>
          <input type="text" class="form-control" formControlName="website_url" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.LINK_EXHIBITORS' | translate }}</label>
          <input type="text" class="form-control" formControlName="link_exhibitors" />
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.YEAR_EXHIBITORS' | translate }}</label>
          <input type="number" class="form-control" formControlName="year_exhibitors" />
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.VENUE' | translate }}</label>
          <app-venue-select [parentFormGroup]="form" [passFormControlName]="'venue_id'"></app-venue-select>
        </div>
      </div>

      <div class="col-sm-9">
        <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.EVENTGROUP"></app-tags-select>
      </div>

      <div class="col-sm-12">
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" formControlName="active" id="active" />
          <label class="form-check-label" for="active">{{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.ACTIVE' | translate }}</label>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" formControlName="show_to_web" id="show-to-web" />
          <label class="form-check-label" for="show-to-web">{{
            'EVENT_GROUPS.EVENT_GROUPS_FORM.SHOW_TO_WEB' | translate
          }}</label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="event-group-form" [disabled]="form.invalid">
    {{ 'EVENT_GROUPS.EVENT_GROUPS_FORM.SAVE' | translate }}
  </button>
</div>
